// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"a5d350ec","977":"3f66f735"}[chunkId] + ".chunk.js");